module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B099TVLM6B.f41aaac4.jpg";